$(document).ready(function () {
  $("nav.header__inline-menu .header__menu-item").hover(
    function () {
      $("sticky-header.header-wrapper").addClass("bghover");
    },
    function () {
      $("sticky-header.header-wrapper").removeClass("bghover");
    }
  );
  $("li.has-item").hover(
    function () {
      $(this).find("details").attr("open", true);
    },
    function () {
      $(this).find("details").removeAttr("open");
    }
  );
  const main_swiper_thumbnail = new Swiper(".main-gallery-thumbnails", {
    direction: "vertical",
    slidesPerView: 4,
    speed: 1500,
  });
  const main_thumb_swiper = new Swiper(".main-gallery-slider", {
    thumbs: {
      swiper: main_swiper_thumbnail,
    },
  });
  $(".main-gallery-thumbnails .swiper-slide").on("mouseover", function () {
    main_thumb_swiper.slideTo($(this).index());
  });


    // Listen for variant change
   document.addEventListener('variant:change', function(event) {
  const variant = event.detail.variant;
  if (!variant || !variant.featured_media) return;

  const mediaId = variant.featured_media.id;

  const slides = document.querySelectorAll('.main-gallery-slider .swiper-slide');

  slides.forEach(function(slide, index) {
    if (
      slide.dataset.mediaId == mediaId || // ← this is cleaner
      slide.querySelector('[data-media-id]')?.dataset.mediaId == mediaId
    ) {
      main_thumb_swiper.slideTo(index);
    }
  });
});

  const radiosJSON = document.querySelector('variant-radios script[type="application/json"]');
  const allVariants = JSON.parse(radiosJSON.textContent);

  // 👇 Listen to radio input change
  document.querySelectorAll('variant-radios input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', () => {
      const value = radio.value;

      const variant = allVariants.find(v => v.option1 === value);

      if (variant) {
        const event = new CustomEvent('variant:change', {
          detail: { variant: variant },
          bubbles: true
        });
        document.dispatchEvent(event);
      }
    });
  });
  
  const half_swiper_thumbnail = new Swiper(".half-gallery-thumbnails", {
    direction: "vertical",
    slidesPerView: 1,
    speed: 1000,
  });
  $(".Highlights-toggle").hover(function () {
    $(".Highlights-toggle").removeClass("Highlights-toggle__active");
    $(this).addClass("Highlights-toggle__active");
    half_swiper_thumbnail.slideTo(parseInt($(this).index()) - 1);
  });
  var quoteSwiper = new Swiper(".testinomial-slider", { speed: 1000 });

  var imageSwiper = new Swiper(".half-gallery-container", {
    direction: "vertical",
    speed: 1000,
    loop: false,
    longSwipesRatio: 0.01,
    parallax: true,
  });
  $(".testinomial-header .testnomi-head").hover(function () {
    quoteSwiper.slideTo(parseInt($(this).index()));
    imageSwiper.slideTo(parseInt($(this).index()));
  });
  var apptxtslider = new Swiper(".app-txt-slider", {
    loop: true,
    speed: 1000,
    navigation: {
      nextEl: ".app-slider-navigation",
    },
  });
  var appimgslider = new Swiper(".app-image-slider", {
    loop: true,
    speed: 1000,
    pagination: {
      el: ".swiper-pagination",
    },
    navigation: {
      nextEl: ".app-slider-navigation",
    },
  });
  var pointerSlider = new Swiper(".pointer-slider", { speed: 1000 });

  $(".Slider-with-navigation-content-navigation-item").hover(function () {
    $(".Slider-with-navigation-content-navigation-item").removeClass(
      "Slider-with-navigation-content-navigation-item__active"
    );
    $(this).addClass("Slider-with-navigation-content-navigation-item__active");
    pointerSlider[0].slideTo($(this).data("slide-index"));
    pointerSlider[1].slideTo($(this).data("slide-index"));
  });

  var fullWidthSlider = new Swiper(".full-width-slide-container", {
    speed: 1500,
    navigation: {
      nextEl: ".Slider-with-video-button-next",
      prevEl: ".Slider-with-video-button-prev",
    },
  });

  $("article.Product-card.Section").hover(
    function () {
      $(this).find(".Product-card-initial").removeClass("u-show");
      $(this).find(".Product-card-initial").addClass("u-hide");
      $(this).find(".Product-card-alt").removeClass("u-hide");
      $(this).find(".Product-card-alt").addClass("u-show");
    },
    function () {
      $(this).find(".Product-card-alt").removeClass("u-show");
      $(this).find(".Product-card-alt").addClass("u-hide");
      $(this).find(".Product-card-initial").removeClass("u-hide");
      $(this).find(".Product-card-initial").addClass("u-show");
    }
  );

  $("article.Product-card").hover(
    function () {
      $(this).find(".Product-card-alt").removeClass("u-hidden");
      $(this).find(".Product-card-initial").addClass("u-hidden");
      $(this)
        .find(".Product-card-details.js-product-details>div")
        .addClass("u-hidden");
    },
    function () {
      $(this).find(".Product-card-alt").addClass("u-hidden");
      $(this).find(".Product-card-initial").removeClass("u-hidden");
      $(this)
        .find(".Product-card-details.js-product-details>div")
        .removeClass("u-hidden");
    }
  );

  $(function () {
    var fromside = "top";
    $(".quick-add__submit, .banner__buttons a.button").hover(
      function (e) {
        var el_pos = $(this).offset();
        var edge = closestEdge(
          e.pageX - el_pos.left,
          e.pageY - el_pos.top,
          $(this).width(),
          $(this).height()
        );
        $(this).addClass(edge);
        fromside = edge;
      },
      function (e) {
        $(this).removeClass(fromside);
      }
    );
  });

  function closestEdge(x, y, w, h) {
    var topEdgeDist = distMetric(x, y, w / 2, 0);
    var bottomEdgeDist = distMetric(x, y, w / 2, h);
    var leftEdgeDist = distMetric(x, y, 0, h / 2);
    var rightEdgeDist = distMetric(x, y, w, h / 2);

    var min = Math.min(
      topEdgeDist,
      bottomEdgeDist,
      leftEdgeDist,
      rightEdgeDist
    );
    switch (min) {
      case leftEdgeDist:
        return "left";
      case rightEdgeDist:
        return "right";
      case topEdgeDist:
        return "top";
      case bottomEdgeDist:
        return "bottom";
    }
  }

  function log(msg) {
    $("#console").append("<pre>" + msg + "</pre>");
  }

  function distMetric(x, y, x2, y2) {
    var xDiff = x - x2;
    var yDiff = y - y2;
    return xDiff * xDiff + yDiff * yDiff;
  }

  $(".video-play-pause .pause").click(function () {
    $(".video-with-text-section video").get(0).pause();
    $(this).addClass("hidden");
    $(".video-play-pause .play").removeClass("hidden");
  });

  $(".video-play-pause .play").click(function () {
    $(".video-with-text-section video").get(0).play();
    $(this).addClass("hidden");
    $(".video-play-pause .pause").removeClass("hidden");
  });

  const swiperallproducts = new Swiper(".Collection-slider-container", {
    direction: "horizontal",
    slidesPerView: 1.2,
    threshold: 50,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    a11y: {
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
    },
    keyboard: { enabled: true, onlyInViewport: false },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
      bulletActiveClass: "active",
    },
    breakpoints: {
      768: { slidesPerView: 2.3 },
      1024: { slidesPerView: 2.6, spaceBetween: 20, pagination: true },
      1380: { slidesPerView: 3, spaceBetween: 20 },
    },
  });

  const section = $(".Collection-slider").first();
  const customCursorContainer = section.find(".Custom-cursor-wrapper").first();
  const customCursor = customCursorContainer.find(".Custom-cursor").first();
  const carouselArrowNext = section.find(".swiper-button-next");
  const carouselArrowPrev = section.find(".swiper-button-prev");
  const updateCustomCursorVisible = function (isVisible) {
    if (isVisible) customCursor.addClass("Custom-cursor__visible");
    else customCursor.removeClass("Custom-cursor__visible");
  };
  const moveCursor = (e) => {
    if (customCursor)
      TweenMax.to(customCursor, 0.25, {
        css: { left: e.clientX, top: e.clientY },
      });
  };
  const next = $(".Collection-slider-container .swiper-button-next");
  const prev = $(".Collection-slider-container .swiper-button-prev");
  const disableCustomCursor = function () {
    customCursorContainer.addClass("Custom-cursor-wrapper__disabled");
    customCursor.addClass("Custom-cursor__disabled");
  };
  section.on("mouseenter", function () {
    updateCustomCursorVisible(false);
  });
  section.on("mouseleave", function () {
    updateCustomCursorVisible(false);
  });
  section.on("mousemove", function (e) {
    updateCustomCursorVisible(true);
    moveCursor(e);
  });
  customCursor.on("click", function () {
    disableCustomCursor();
  });
  carouselArrowNext.on("mouseover", function () {
    disableCustomCursor();
  });
  carouselArrowPrev.on("mouseover", function () {
    disableCustomCursor();
  });
});
